import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Deliverables } from './components/sections/Deliverables';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { AboutAuthor } from './components/sections/AboutAuthor';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
interface AppProps {
  showSocialProofPopup?: boolean;
  showFloatingCTA?: boolean;
}
export function App({
  showSocialProofPopup = true,
  showFloatingCTA = true
}: AppProps) {
  return <div className="w-full overflow-x-hidden bg-cream font-sans antialiased" data-id="element-0" data-mp="3mjgclt42snpw">
      <MetaPixel data-id="element-1" data-mp="3rcsuzli5vya7" />
      <main data-id="element-2" data-mp="3recc1ebn6dd1">
        <Hero data-id="element-3" data-mp="5yimri0b7dt" />
        <Stats data-id="element-4" data-mp="6hqffdy0fe4" />
        <BeforeAfter data-id="element-5" data-mp="682rygdekbl" />
        <PainPoints data-id="element-6" data-mp="5gfdawxfswe" />
        <Volumes data-id="element-7" data-mp="82jf0klzq9v" />
        <Deliverables data-id="element-8" data-mp="2zl3c5m4yv85u" />
        <Bonuses data-id="element-9" data-mp="2zlv66six0xu0" />
        <Offer data-id="element-10" data-mp="2zmepackaxs9m" />
        <Guarantee data-id="element-11" data-mp="2zmo89g6xiz5t" />
        <Testimonials data-id="element-12" data-mp="2zng14j956ise" />
        <AboutAuthor data-id="element-13" data-mp="33mf0loc3tncg" />
        <Faq data-id="element-14" data-mp="33nq6btp41567" />
        <FinalCTA data-id="element-15" data-mp="33ngfk3w8qtzg" />
      </main>
      <Footer data-id="element-16" data-mp="33orkw85c49so" />
      {showFloatingCTA && <FloatingCTA data-id="element-17" data-mp="38l8h7pmotugu" />}
      {showSocialProofPopup && <PurchasePopup data-id="element-18" data-mp="38kgmsi4tu2s5" />}
    </div>;
}